import { Action, createReducer, on } from "@ngrx/store";
import * as brandsActions from './brands.actions';
import { IPagination } from "src/app/shared/models/page.model";
import { IBrand } from "../models/brands.models";

export interface BrandsState {
  allBrands: IBrand[],
  metadata: IPagination | null;
  brands: IBrand[],
  loading: boolean,
  keyword: string
}

export const initialBrandsState: BrandsState = {
  allBrands: [],
  metadata: null,
  brands: [],
  loading: false,
  keyword: ''
}

const featureReducer = createReducer(
  initialBrandsState,
  on(
    brandsActions.FetchAllBrandsSuccess,
    (state, action) => ({
      ...state,
      allBrands: action.brands,
    })
  ),
  on(
    brandsActions.FetchBrandsSuccess,
    (state, action) => ({
      ...state,
      brands: action.append
        ? [
            ...state.brands,
            ...action.brands.data.filter(
              (incoming) => !state.brands.some((existing) => existing.id === incoming.id)
            ),
          ]
        : action.brands.data,
      metadata: action.brands.metadata
    })
  ),
  on(brandsActions.AddBrandSuccess, (state, action) => ({
    ...state,
    allBrands: [...state.allBrands, action.brand as IBrand]
  })),
  on(brandsActions.SetBrandsLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(brandsActions.SetBrandSearch, (state, action) => ({
    ...state,
    keyword: action.keyword
  })),
)

export function brandsReducer(state: BrandsState | undefined, action: Action) {
  return featureReducer(state, action);
}
